const IconSize = {
	large: "60px",
	medium: "37px",
	small: "28px",
	"very-small": "15px",
	menu: "23px"
}

export default IconSize
